import { render, staticRenderFns } from "./Mechanics.vue?vue&type=template&id=c448b010&scoped=true&"
import script from "./Mechanics.vue?vue&type=script&lang=js&"
export * from "./Mechanics.vue?vue&type=script&lang=js&"
import style0 from "./Mechanics.vue?vue&type=style&index=0&id=c448b010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c448b010",
  null
  
)

export default component.exports